import CompareZoneBase from 'components/Catalog/ProductGrid/CompareModal/Zones/CompareZoneBase/CompareZoneBase';

export default CompareZoneBase;
